/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { inheritsLoose as _inheritsLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { z } from 'zod';
import { OPERATION } from './enums.js';
import { BaseOperator } from './helpers.js';
import { ValidationFailedError } from '../errors.js';
import { BANK_ACCOUNT_VERIFICATION_COMMERCIAL_REQUEST_TYPE } from '../../consts/index.js';

// These rules are required in order to pass the bank account verification check
var requiredRules = ['CMM1069', 'CMM1048', 'CMM1052'];
var BankAccountVerification = /*#__PURE__*/function (_BaseOperator) {
  function BankAccountVerification() {
    return _BaseOperator.call(this, {
      operator: OPERATION.BANK_ACCOUNT_VERIFICATION
    }) || this;
  }
  _inheritsLoose(BankAccountVerification, _BaseOperator);
  var _proto = BankAccountVerification.prototype;
  _proto.extractValue = function extractValue(data) {
    var bankAccountVerificationSchema = z.object({
      pluginsOutput: z.object({
        bankAccountVerification: z.object({
          data: z.object({
            responseHeader: z.object({
              requestType: z.string()
            }),
            clientResponsePayload: z.object({
              decisionElements: z.array(z.record(z.string(), z.unknown()))
            })
          })
        })
      })
    }).transform(function (_ref) {
      var _ref$pluginsOutput$ba = _ref.pluginsOutput.bankAccountVerification.data,
        requestType = _ref$pluginsOutput$ba.responseHeader.requestType,
        decisionElements = _ref$pluginsOutput$ba.clientResponsePayload.decisionElements;
      return {
        requestType: requestType,
        rules: decisionElements.filter(function (element) {
          return !!element.rules;
        }).flatMap(function (element) {
          return element.rules;
        })
      };
    });
    var result = bankAccountVerificationSchema.safeParse(data);
    if (!result.success) {
      throw new ValidationFailedError('Extract value', 'parsing failed', result.error);
    }
    if (result.data.requestType !== BANK_ACCOUNT_VERIFICATION_COMMERCIAL_REQUEST_TYPE) {
      return [];
    }
    var rulesResult = z.array(z.object({
      ruleId: z.string(),
      ruleScore: z.number()
    })).safeParse(result.data.rules);
    if (!rulesResult.success) {
      throw new ValidationFailedError('Extract value', 'parsing failed', rulesResult.error);
    }
    var rules = rulesResult.data.filter(function (rule) {
      return requiredRules.includes(rule.ruleId);
    });
    if (rules.length < 3) {
      throw new ValidationFailedError('Extract value', 'less than 3 rules');
    }
    return rules;
  };
  _proto.evaluate = function evaluate(dataValue) {
    return dataValue.length === 0 || dataValue.every(function (rule) {
      return rule.ruleScore === 0;
    });
  };
  return BankAccountVerification;
}(BaseOperator);
var BANK_ACCOUNT_VERIFICATION = new BankAccountVerification();

export { BANK_ACCOUNT_VERIFICATION, BankAccountVerification };
//# sourceMappingURL=bank-account-verification.js.map
